// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"791":"ecdf0880efdffce9","809":"4009f68d4ce87712"}[chunkId] + ".js";
};